import { Navigate } from 'react-router-dom';
import { requiredAuthPermission } from '../common/constants/UserPermissionConstants';
import { RouteObject } from '../common/types/interfaces';
import DashboardMain from '../dashboard/features/DashboardMain/DashboardMain';
import ConnectorDetail from './modules/connectors/connector-detail/ConnectorDetail';
import ConnectorList from './modules/connectors/connector-list/ConnectorList';
import EventsWrapper from './modules/events/event-details';
import EventsListWrapper from './modules/events/event-list/list-event-wrapper/EventsListWrapper';
import EventsAssociationsWrapper from './modules/events/events-associations/events-associations-wrapper/EventsAssociationsWrapper';
import ImportEvents from './modules/events/import-file-events/import-events/ImportEvents';
import ExceptionTable from './modules/exceptions/exception-list/list-exception/ExceptionList';
import ExceptionWrapper from './modules/exceptions/exception-wrapper/ExceptionWrapper';
import { JoltConfigurations } from './modules/jolt-mapping-configuration/JoltMappingConfiguration';
import { ConfigurationWrapper } from './modules/schedule-maintenance/schedule-maintenance-wrapper/ScheduleMaintenanceWrapper';
import ScheduledMaintenanceDetailsWrapper from './modules/schedule-maintenance/schedule-maintenance-wrapper/scheduled-maintenance-details-wrapper/ScheduledMaintenanceDetailsWrapper';
import ImportServices from './modules/services/import-file-services/import-services/ImportServices';
import ServiceAssociationWrapper from './modules/services/service-association/service-association-wrappers/ServiceAssociationWrapper';
import ServiceListWrapper from './modules/services/service-list/list-service-wrapper/ServiceListWrapper';
import ServiceWrapper from './modules/services/service-wrapper/ServiceWrapper';
import RegistriesWrapper from './modules/sources/SourcesWrapper';
import SourceRegistryWrapper from './modules/sources/source-registry/source-registry-wrapper/SourceRegistryWrapper';
import AiServicePage from '../ai-service/AiServicePage';
import { URL_PATH } from './constants';

export const routeObject: RouteObject[] = [
  {
    path: '/',
    element: <Navigate to="dashboard" replace />,
    requiredPermissions: [requiredAuthPermission.Events.view, requiredAuthPermission.Events.edit, requiredAuthPermission.Events.approve, requiredAuthPermission.Services.view, requiredAuthPermission.Services.edit, requiredAuthPermission.Services.approve, requiredAuthPermission.CP.view, requiredAuthPermission.CP.edit]
  },
  {
    path: 'dashboard',
    element: <DashboardMain />,
    requiredPermissions: [requiredAuthPermission.Events.view, requiredAuthPermission.Events.edit, requiredAuthPermission.Events.approve, requiredAuthPermission.Services.view, requiredAuthPermission.Services.edit, requiredAuthPermission.Services.approve, requiredAuthPermission.CP.view, requiredAuthPermission.CP.edit, requiredAuthPermission.JD.view, requiredAuthPermission.JD.edit, requiredAuthPermission.JD.approve]
  },
  {
    path: 'ai-service',
    element: <AiServicePage />,
    requiredPermissions: [
      requiredAuthPermission.Events.view,
      requiredAuthPermission.Events.edit,
      requiredAuthPermission.Events.approve,
      requiredAuthPermission.Services.view,
      requiredAuthPermission.Services.edit,
      requiredAuthPermission.Services.approve,
      requiredAuthPermission.CP.view,
      requiredAuthPermission.CP.edit
    ]
  },
  {
    path: '/events',
    element: <EventsListWrapper />,
    requiredPermissions: [requiredAuthPermission.Events.view, requiredAuthPermission.Events.edit, requiredAuthPermission.Events.approve]
  },
  {
    path: '/services',
    element: <ServiceListWrapper />,
    requiredPermissions: [requiredAuthPermission.Services.view, requiredAuthPermission.Services.edit, requiredAuthPermission.Services.approve]
  },
  {
    path: '/events/createEvent',
    element: <EventsWrapper />,
    requiredPermissions: [requiredAuthPermission.Events.edit, requiredAuthPermission.Events.approve]
  },
  {
    path: '/events/create',
    element: <Navigate to="/control-plane/events/createEvent" replace />,
    requiredPermissions: [requiredAuthPermission.Events.edit, requiredAuthPermission.Events.approve]
  },
  {
    path: '/events/:mode/:eventname/:version',
    element: <EventsWrapper />,
    requiredPermissions: [requiredAuthPermission.Events.view, requiredAuthPermission.Events.edit, requiredAuthPermission.Events.approve]
  },
  {
    path: '/events/event-association/:eventName/:eventVersion/:associationTab/*',
    element: <EventsAssociationsWrapper />,
    requiredPermissions: [requiredAuthPermission.Events.view, requiredAuthPermission.Events.edit, requiredAuthPermission.Events.approve]
  },
  {
    path: '/services/service-association/',
    element: <ServiceAssociationWrapper />,
    requiredPermissions: [requiredAuthPermission.Events.view, requiredAuthPermission.Events.edit, requiredAuthPermission.Events.approve]
  },
  {
    path: '/services/*',
    element: <ServiceWrapper />,
    requiredPermissions: [requiredAuthPermission.Services.view, requiredAuthPermission.Services.edit, requiredAuthPermission.Services.approve]
  },
  {
    path: '/connectors',
    element: <ConnectorList />,
    requiredPermissions: [requiredAuthPermission.CP.view, requiredAuthPermission.CP.edit]
  },
  {
    path: '/connectors/connectorDetails/:id',
    element: <ConnectorDetail />,
    requiredPermissions: [requiredAuthPermission.CP.view, requiredAuthPermission.CP.edit]
  },
  {
    path: '/exceptions',
    element: <ExceptionTable />,
    requiredPermissions: [requiredAuthPermission.CP.view, requiredAuthPermission.CP.edit]
  },
  {
    path: '/exceptions/create',
    element: <ExceptionWrapper />,
    requiredPermissions: [requiredAuthPermission.CP.edit]
  },
  {
    path: '/exceptions/:mode/:exceptionName/:version',
    element: <ExceptionWrapper />,
    requiredPermissions: [requiredAuthPermission.CP.view, requiredAuthPermission.CP.edit]
  },
  {
    path: '/registries',
    element: <Navigate to={`${URL_PATH.REGISTRIES}/source-registry`} replace />,
    requiredPermissions: [requiredAuthPermission.CP.view, requiredAuthPermission.CP.edit]
  },
  {
    path: '/registries/source-registry',
    element: <RegistriesWrapper />,
    requiredPermissions: [requiredAuthPermission.CP.view, requiredAuthPermission.CP.edit]
  },
  {
    path: '/registries/source-registry/create',
    element: <SourceRegistryWrapper />,
    requiredPermissions: [requiredAuthPermission.CP.edit]
  },
  {
    path: '/registries/source-registry/view/:sourcename/:version',
    element: <SourceRegistryWrapper />,
    requiredPermissions: [requiredAuthPermission.CP.view, requiredAuthPermission.CP.edit]
  },
  {
    path: '/registries/source-registry/edit/:sourcename/:version',
    element: <SourceRegistryWrapper />,
    requiredPermissions: [requiredAuthPermission.CP.view, requiredAuthPermission.CP.edit]
  },
  {
    path: '/events/*',
    element: <ImportEvents />,
    requiredPermissions: [requiredAuthPermission.CP.view, requiredAuthPermission.CP.edit]
  },
  {
    path: '/services/files/*',
    element: <ImportServices />,
    requiredPermissions: [requiredAuthPermission.CP.view, requiredAuthPermission.CP.edit]
  },
  {
    path: '/jolt',
    element: <JoltConfigurations />,
    requiredPermissions: [requiredAuthPermission.CP.view, requiredAuthPermission.CP.edit]
  },
  {
    path: '/configuration',
    element: <Navigate to={`${URL_PATH.CONTROL_PLANE}/configuration/schedule-maintenance`} replace />,
    requiredPermissions: [requiredAuthPermission.CP.view, requiredAuthPermission.CP.edit]
  },
  {
    path: '/configuration/schedule-maintenance',
    element: <ConfigurationWrapper />,
    requiredPermissions: [requiredAuthPermission.CP.view, requiredAuthPermission.CP.edit]
  },
  {
    path: '/configuration/schedule-maintenance/:mode/:maintenancename',
    element: <ScheduledMaintenanceDetailsWrapper />,
    requiredPermissions: [
      requiredAuthPermission.Maintainence.edit,
      requiredAuthPermission.Maintainence.view
    ]
  },
  {
    path: '/configuration/schedule-maintenance/add',
    element: <ScheduledMaintenanceDetailsWrapper />,
    requiredPermissions: [requiredAuthPermission.Maintainence.edit]
  },
];
